import { render, staticRenderFns } from "./BotaoGerarIA.vue?vue&type=template&id=287da336&scoped=true"
import script from "./BotaoGerarIA.vue?vue&type=script&lang=js"
export * from "./BotaoGerarIA.vue?vue&type=script&lang=js"
import style0 from "./BotaoGerarIA.vue?vue&type=style&index=0&id=287da336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287da336",
  null
  
)

export default component.exports